<template>
  <el-dialog title="操作详情" :visible.sync="dialogTableVisible" :append-to-body="true" :close-on-click-modal="false">
    <div class="gundongds">
      <dataTable
        ref="dataTable"
        :flush="fresh"
        :inSerachFilte="inSerachFilte"
        :inTableData="tableDataConfig"
        :inAjax="tableAjaxConfig"
        :ispagination="true"
        :isAjax="isAjax"
      ></dataTable>
    </div>
  </el-dialog>
</template>

<script>
  import dataTable from "../../components/commonComponents/dataTable";
  import GlobalUtil from '@/utils/globalUtil'

  export default {
    components: {
      dataTable
    },
    data() {
      return {
        isAjax: false,
        dialogTableVisible: false,
        //用于tableData组件刷新，tableData检测到fresh值发生变化就会刷新数据
        fresh: "",
        // 用于匹配搜索数据，返回新的数据
        inSerachFilte: {},
        //tableData组件参数配置
        tableDataConfig: {
          //表头及字段配置
          tHead: [
            {
              name: "操作项",
              field: "acOption"
            },
            {
              name: "操作详情",
              field: "content"
            },
            {
              name: "操作人",
              field: "handleName"
            },
            {
              name: "操作时间",
              field: "createDate"
            }
          ],
          //自动渲染
          tData: [],
          //自动渲染
          total: 0,
          actionBtWidth: "250",
          //配置是否显示多选框
          isMultiple: false,
          dispatchp: false,
          //配置是否显示排序
          isRank: true
        },
        tableAjaxConfig: {
          url: this.$url.getLogPage,
          method: 'post',
          data: {
            pageNumber: 1,
            pageSize: 15,
            queryObj: {}
          }
        }
      };
    },
    methods: {
      query(row, data) {
        this.tableAjaxConfig.data.queryObj = {
          moduleEq: data,
          handleIdEq: row.id,
          entCodeEq: GlobalUtil.readCookie("entCodeEq")
        }
        this.dialogTableVisible = true;
        this.isAjax = true;
        this.$nextTick(() => {
          this.$refs.dataTable.getList()
        })
      }
    },
    created() {
      console.log(this.tableDataConfig)
    }
  };
</script>

<style lang='less' scoped>
  .gundongds {
    max-height: 550px;
    overflow-y: auto;
  }
</style>
